var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPerson24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.4C17.7438 22.4 22.4 17.7437 22.4 12C22.4 6.25621 17.7438 1.59998 12 1.59998C6.25624 1.59998 1.60001 6.25621 1.60001 12C1.60001 17.7437 6.25624 22.4 12 22.4Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.25C13.5533 6.25 14.8125 7.5092 14.8125 9.0625C14.8125 10.6158 13.5533 11.875 12 11.875C10.4467 11.875 9.1875 10.6158 9.1875 9.0625C9.1875 7.5092 10.4467 6.25 12 6.25ZM12 5.125C9.82538 5.125 8.0625 6.88788 8.0625 9.0625C8.0625 11.2371 9.82538 13 12 13C14.1746 13 15.9375 11.2371 15.9375 9.0625C15.9375 6.88788 14.1746 5.125 12 5.125ZM17.625 20.875H16.5V18.0625C16.5 17.3166 16.2037 16.6012 15.6762 16.0738C15.1488 15.5463 14.4334 15.25 13.6875 15.25H10.3125C8.7592 15.25 7.5 16.5092 7.5 18.0625V20.875H6.375V18.0625C6.375 15.8879 8.13788 14.125 10.3125 14.125H13.6875C15.8621 14.125 17.625 15.8879 17.625 18.0625V20.875Z",
    fill: "#CACACA"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-24.45936c3f49cd8a5bc415580852f13007.svg";